<template>
	<div>
		<div v-show="!showFields && projectConfigurationLoaded">
			<v-toolbar color="blue" class="white--text">
				<v-toolbar-title>Porównywane wersje są identyczne</v-toolbar-title>
			</v-toolbar>
		</div>
		<div v-if="current && projectConfigurationLoaded">
			<compareTitles
				:current="current.title"
				:old="old.title"
				@dataDiffer="showDifference"
			/>

			<compare-english-titles
				:current="current.englishTitle"
				:old="old.englishTitle"
				@dataDiffer="showDifference"
			/>

			<compare-priority-tree
				:contest-id="current.contestId"
				:current="current.prioritiesData"
				:old="old.prioritiesData"
				@dataDiffer="showDifference"
			/>

			<compare-summary-bidder-details
				:current-main="current.mainBidder"
				:old-main="old.mainBidder"
				:current-others="current.otherBidders"
				:old-others="old.otherBidders"
				@dataDiffer="showDifference"
			/>

			<compare-countries-fundings
				:contest-id="current.contestId"
				:current="current.financesData"
				:old="old.financesData"
				@dataDiffer="showDifference"
			/>

			<compare-dac-codes
				:contest-id="current.contestId"
				:current="current.dacCodes"
				:old="old.dacCodes"
				@dataDiffer="showDifference"
			/>

			<compare-start-end
				:current="current.dates"
				:old="old.dates"
				@dataDiffer="showDifference"
			></compare-start-end>

			<compare-volunteers
				:current="current.volunteers"
				:current-global-init="current.globalInitiative"
				:current-global-init-description="current.globalInitiativeDescription"
				:old="old.volunteers"
				:old-global-init="old.globalInitiative"
				:old-global-init-description="old.globalInitiativeDescription"
				@dataDiffer="showDifference"
			></compare-volunteers>

			<compare-project-actions
				:contest-id="current.contestId"
				:current="current.actionsData"
				:old="old.actionsData"
				@dataDiffer="showDifference"
			/>

			<compare-locations
				:current="current.locations"
				:old="old.locations"
				@dataDiffer="showDifference"
			/>

			<compare-project-costs-table
				:configuration="projectConfiguration"
				:old-actions="old.actionsData"
				:old-actions-costs="old.actionsCosts"
				:old-actions-costs-actions-ids="old.actionsCostsActionIds"
				:old-administrative-costs="old.administrativeCosts"

				:current-actions="current.actionsData"
				:current-actions-costs="current.actionsCosts"
				:current-actions-costs-actions-ids="current.actionsCostsActionIds"
				:current-administrative-costs="current.administrativeCosts"

				@dataDiffer="showDifference"
			/>

			<div v-for="(section, index) in persistentGenericMap()" v-bind:key="index">
				<template v-if="showFormComparison">
					<h2 style="margin-left: 20px" >{{projectConfiguration.genericPartScheme.sections[index].name}} </h2>
					<vue-form-generator
						:disabled="true"
						:name="'persistentGenerator-'.concat(index)"
						:model="section.model"
						:schema="section.schema"
					/>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
  import CompareTitles from "../../offer/compareComponents/CompareTitles";
  import CompareEnglishTitles from "../../offer/compareComponents/CompareEnglishTitles";
  import ComparePriorityTree from "../../offer/compareComponents/ComparePriorityTree";
  import CompareCountriesFundings from "../../offer/compareComponents/CompareCountriesFundings";
  import CompareDacCodes from "../../offer/compareComponents/CompareDacCodes";
  import CompareStartEnd from "../../offer/compareComponents/CompareStartEnd";
  import CompareLocations from "../../offer/compareComponents/CompareLocations";
  import CompareVolunteers from "../../offer/compareComponents/CompareVolunteers";
  import {genericFormUtil} from "@/utils/genericFormUtil";
  import CompareSummaryBidderDetails from "@/view/logged/offer/compareComponents/CompareSummaryBidderDetails";
  import CompareProjectActions from "@/view/logged/project/compareComponents/CompareProjectActions";
  import CompareProjectCostsTable from "@/view/logged/project/compareComponents/CompareProjectCostsTable";

  export default {
    name: "ProjectDifferencesView",

    components: {
      CompareProjectCostsTable, CompareProjectActions, CompareSummaryBidderDetails, CompareVolunteers, CompareLocations, CompareStartEnd,
      CompareDacCodes, CompareCountriesFundings, ComparePriorityTree, CompareEnglishTitles, CompareTitles
    },

    data () {
      return {
        showFields: false,
        showFormComparison: false
      };
    },

    methods: {
      persistentGenericMap () {
        if (this.projectConfiguration.genericPartScheme === null
            || this.old.genericModel === null
            || this.current.genericModel === null) {
          return null;
        } else {
          let sectionsArray = [];
          for (let i = 0; i < this.projectConfiguration.genericPartScheme.sections.length; i++) {
            sectionsArray.push(this.prepareSchemaAndModelForSection(i));
          }
          if (sectionsArray.some(section => !section.dataSame)) {
            this.showFormComparison = true;
            this.showDifference();
          }
          return sectionsArray;
        }
      },

      prepareSchemaAndModelForSection (i) {
        let oldSchema = this.getPersistentSchemaForComparing(this.old.genericModel, i);
        let currentSchema = this.getPersistentSchemaForComparing(this.current.genericModel, i);
        return genericFormUtil.mergeTwoSchemasAndModelToCompare(oldSchema, currentSchema, this.old.genericModel.sections[i], this.current.genericModel.sections[i]);
      },

      getPersistentSchemaForComparing(model, sectionIndex) {
        let sections = model.sections;
        let schema = genericFormUtil.getSectionSchemaFromSchema(this.projectConfiguration.genericPartScheme, sectionIndex, true);
        if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
          let schemaValues = sections[sectionIndex].fields;
          return genericFormUtil.filterSchemaByConditionalFieldsValue(schema, schemaValues);
        } else {
          return schema;
        }
      },

      showDifference() {
        this.showFields = true;
      }
    },

    props: {
      old: {type: Object, required: true},
      current: {type: Object, required: true},
      projectConfiguration: {type: Object, required: true},
      projectConfigurationLoaded: {type: Boolean, default: false},
    }
  };
</script>

<style scoped>

</style>